/**
 * Fenced code display with decorative header.
 *
 * Props:
 *   code  — string content to display
 *   title — optional label shown in the header bar
 */
export default function CodeBlock({ code, title = 'example' }) {
  return (
    <div className="code-block">
      <div className="code-block-header">
        <div className="dots">
          <span />
          <span />
          <span />
        </div>
        {title}
      </div>
      <pre>{code}</pre>
    </div>
  );
}
